export const GET_ALL_REVIEWS = 'GET_ALL_REVIEWS'
export const GET_ALL_REVIEWS_RES = 'GET_ALL_REVIEWS_RES'
export const GET_REVIEW_BY_ID = 'GET_REVIEW_BY_ID'
export const GET_REVIEW_BY_ID_RES = 'GET_REVIEW_BY_ID_RES'
export const REQUEST_CANCEL = 'REQUEST_CANCEL'
